

export default function TargetsProgressInfo(props) {
    return (

        <div className="flex gap-4">
            <div className={` w-20 h-[75px] text-xl flex justify-center items-center + ${props.squareColor} + ${props.iconColor}`}>
                <i>{props.icon}</i>
            </div>
            <ul className="flex-1 flex flex-col justify-evenly">
                <li className="text-gray-500">{props.title}</li>
                <li className="font-bold text-[1rem]">{props.number}</li>
                <li className={"w-full h-1 rounded-md relative " + props.progressColor}><span className={props.insideProgressColor + " absolute h-full " + props.insideProgressWidth + ` before:bg-inherit before:tipTop after:tipTopAfter ${props.colorTip} ` + props.tipTopValue}></span></li>
            </ul>
        </div >

    )
}
